/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import Tysiav2Bills from 'DesignSystem/Svgs/Tysiav2Bills/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ProfileActions/LedgerAction/Content",
  type = "secondary"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  type
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClick}
 size="small"
 type={type}
 title="Ledger"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2Bills
{...childProps}
  viewPath={`${viewPath}/Tysiav2Bills`}
 width={type === 'ghost' ? "14px" : "12px"}
 height={type === 'ghost' ? "14px" : "12px"}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}